import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';
import PopupFacade from 'components/popup/popupFacade';

const projectMainSlider = document.querySelector('.j-project-main-slider');
let slider = {};

const buttonsListener = () => {
    const fullImgBtns = Array.from(document.querySelectorAll('.j-project-main-full'));

    if (fullImgBtns.length) {
        const options = {
            openButtons: fullImgBtns,
            modify     : ''
        };

        new PopupFacade(options).init();
    }
};

if (projectMainSlider) {
    const options = {
        modules          : [Autoplay, Navigation, Pagination],
        loop             : true,
        speed            : 800,
        spaceBetween     : 10,
        slidesPerView    : 'auto',
        slidesOffsetAfter: 0,
        autoplay         : {
            delay: 6000
        },
        pagination: {
            el  : '.j-project-main-pagination',
            type: 'custom',
            renderCustom(_, current, total) {
                const newCurrent = current < 10 ? `0${current}` : current;
                const newTotal = total < 10 ? `0${total}` : total;

                return `<span class="slider-control__current">${newCurrent}</span>
                           <span class="slider-control__total">/ ${newTotal}</span>`;
            }
        },
        navigation: {
            nextEl: '.j-project-main-next',
            prevEl: '.j-project-main-prev'
        },
        breakpoints: {
            1280: {
                allowTouchMove: false,
                spaceBetween  : 0
            }
        },
        on: {
            afterInit: () => {
                buttonsListener();
            }
        }
    };

    slider = new Swiper(projectMainSlider, options);
    slider.init();
}
